/* eslint-disable lines-between-class-members */
import { Expose } from "class-transformer";

import { BaseModel } from "src/shared/models/base.model";
import { DebitMembership } from "./debit-membership.model";
import { Coupon } from "./payment-coupon.model";

export class PaymentSummary extends BaseModel {
    @Expose() allowPaymentSplit?: boolean;
    @Expose() policyId?: number;
    @Expose() debitMembership?: DebitMembership | null;
    @Expose() coupons?: Coupon[];
}
